/* eslint-disable import/no-extraneous-dependencies */
import { initializeApp } from 'firebase/app';

import { firebaseOptions } from './firebase-options';

export const firebaseApp = initializeApp(firebaseOptions);
